import type { Me, Permission, Role } from "./types"

/**
 * UI mirror of the backend rules in apps/backend/src/modules/staff-access/permissions.ts
 * (canManageMember / canGrant). The UI only offers what the API will allow;
 * the API still enforces every rule.
 */
export type Verdict = { ok: true } | { ok: false; reason: string }

const ok: Verdict = { ok: true }
const no = (reason: string): Verdict => ({ ok: false, reason })

export function canManageMember(me: Me, target: { id: string; role: Role }): Verdict {
  const s = me.staff
  if (!s) return no("No access.")
  if (target.id === s.id) return no("You can't change your own access. Ask the store owner.")
  if (target.role === "owner") return no("The store owner can only change through an ownership transfer.")
  if (!s.permissions.includes("staff:write")) return no("You don't have permission to manage staff.")
  if (target.role === "admin" && s.role !== "owner") return no("Only the store owner can change staff with full permissions.")
  return ok
}

/** Permissions the signed-in person may hand out; full permissions only for the owner. */
export function grantable(me: Me): { full: boolean; permissions: Set<Permission> } {
  const s = me.staff
  if (!s || !s.permissions.includes("staff:write")) return { full: false, permissions: new Set() }
  return { full: s.role === "owner", permissions: new Set(s.permissions) }
}
